type Props = {
  height?: number;
  width?: number;
  className?: string;
};

const ExternalLink = (props: Props) => {
  const { height = 20, width = 20, className } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      className={className}
      viewBox="0 0 20 20"
    >
      <path
        className="fill-brand"
        d="m14.584 6.292-9.938 9.937a.6.6 0 0 1-.438.188.6.6 0 0 1-.437-.188.6.6 0 0 1-.188-.438.6.6 0 0 1 .188-.437l9.938-9.938h-5.5a.603.603 0 0 1-.446-.18.61.61 0 0 1-.18-.448.61.61 0 0 1 .625-.621h7c.178 0 .326.06.446.18.12.119.18.267.18.444v7c0 .178-.06.326-.181.446a.61.61 0 0 1-.448.18.61.61 0 0 1-.621-.625v-5.5Z"
      />
    </svg>
  );
};
export default ExternalLink;
